import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthenticationService, DataService, LandingPageService, ToastrService} from '../../../_services/index';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {NgForm} from '@angular/forms';
import {filter} from 'rxjs/operators/filter';
import {Subscription} from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'app-new-user',
    templateUrl: './new-user.component.html',
    styleUrls: ['./new-user.component.css'],
    providers: [ToastrService, LandingPageService]
})
export class NewUserComponent implements OnInit, OnDestroy {
    model: any = {};
    mask: any[] = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    loading = false;
    countryList: Array<string>;
    stateList: Array<string>;
    whatBestDescribeYouList: Array<string>;
    zipcodeList: { Min: number; Max: number; State: string }[];
    account: { type: string };
    previousUrl: string;
    urlSubcription: Subscription;
    redemptionParams: any;
    redemptionParamsStringified: string;
    isValidPostalCode = true;
    isValidState = true;
    isValidCountry = true;
    whatBestDescribesYou = true;

    constructor(private _activatedRoute: ActivatedRoute,
                private _router: Router,
                private _dataService: DataService,
                private _authenticationService: AuthenticationService,
                public _toastrService: ToastrService,
                private spinner: NgxSpinnerService,
                private _landingPageService: LandingPageService) {
        this._activatedRoute.queryParams.subscribe(p => {
            this.redemptionParamsStringified = (p['redemptionParams'] || '');
            this.redemptionParams = JSON.parse((p['redemptionParams'] || '{}'));
        });
        // this.urlSubcription = this._router.events
        //     .pipe(filter(event => event instanceof NavigationEnd))
        //     .subscribe((event: NavigationEnd) => {
        //         this._router.url;
        //         console.log('prev:', event.url);
        //         this.previousUrl = event.url;
        //     });
    }

    ngOnInit() {
        this.countryList = this._dataService.getCountries();
        this.whatBestDescribeYouList = this._dataService.getWhatBestDescribesYou();
        this.account = {type: 'personal'};
        this.zipcodeList = this._dataService.getZipcodes();
        this.stateList = this._dataService.getUSStates();
        (<any>window).gtag('config', environment.gaId, {'page_path': `/new-user`});
    }

    getNewUserInsertId(): string {
        return localStorage.getItem('newuserinsertId');
    }

    createSchoolDistrictAccount() {
        const url = '/api/newUser';
        this.loading = true;
        const body = {
            user_id: this.getNewUserInsertId(),
            profile: {
                'user_type': 'school_district',
                'first_name': this.model.first_name,
                'country': this.model.country,
                'state': this.model.state,
                'role': 'user',
                'last_name': this.model.last_name,
                'school_district': this.model.school_district,
                'address1': this.model.address1,
                'address2': this.model.address2,
                'city': this.model.city,
                'phone': this.model.phone || '',
                'postal_code': this.model.postal_code,
                'what_best_describes_you': this.model.what_best_describes_you,
                'school': this.model.school_name || '',
            }
        };
        // console.log(body);
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this._toastrService.typeCustomSuccess(data.response_message);
                        this.redirection((data || {data: ''}).data || '');

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Create Button for New School District Account by User ID ${body.user_id}`
                        });
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                });
    }

    createSchoolTeacherAccount() {
        const url = '/api/newUser';
        this.loading = true;
        const body = {
            user_id: this.getNewUserInsertId(),
            profile: {
                'user_type': 'school_teacher',
                'first_name': this.model.first_name,
                'role': 'user',
                'state': this.model.state,
                'country': this.model.country,
                'last_name': this.model.last_name,
                'school_district': this.model.school_district,
                'school': this.model.school_name || '',
                'address1': this.model.address1,
                'address2': this.model.address2,
                'city': this.model.city,
                'phone': this.model.phone || '',
                'postal_code': this.model.postal_code,
                'what_best_describes_you': this.model.what_best_describes_you
            }
        };
        // console.log(body);
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this._toastrService.typeCustomSuccess(data.response_message);
                        // this._router.navigate(['login', { queryParams: { "redemptionParams": this.redemptionParamsStringified } }]);
                        this.redirection((data || {data: ''}).data || '');

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Create Button for New School Teacher Account by User ID ${body.user_id}`
                        });
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                });
    }

    createPersonalAccount() {
        const url = '/api/newUser';
        this.loading = true;
        const body = {
            user_id: this.getNewUserInsertId(),
            profile: {
                'user_type': 'personal',
                'first_name': this.model.first_name,
                'country': this.model.country,
                'state': this.model.state,
                'role': 'user',
                'last_name': this.model.last_name,
                'school_district': this.model.school_district,
                'address1': this.model.address1,
                'address2': this.model.address2,
                'city': this.model.city,
                'phone': this.model.phone || '',
                'postal_code': this.model.postal_code,
                'what_best_describes_you': this.model.what_best_describes_you,
                'school': this.model.school_name || '',
            }
        };
        // console.log(body);
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this._toastrService.typeCustomSuccess(data.response_message);
                        // this._router.navigate(['login', { queryParams: { "redemptionParams": this.redemptionParamsStringified } }]);
                        this.redirection((data || {data: ''}).data || '');

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Create Button for New Personal Account by User ID ${body.user_id}`
                        });
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                });
    }

    redirection(token) {
        if (token) {
            this._authenticationService.autoLogin(token);
        }
        if ((this.redemptionParams || {}).keyId > 0 && (this.redemptionParams || {}).keyStatus == 'available') {
            this.spinner.show();
            this._landingPageService.setParams(this.redemptionParams);
        } else {
            this._router.navigate(['home']);
        }
    }

    createNewUserAccount(registerForm: NgForm) {
        this.account.type = registerForm.controls['accountType'].value;
        this.whatBestDescribesYou = true;
        this.isValidCountry = true;
        this.isValidState = true;
        // tslint:disable-next-line:max-line-length
        const CountryValue = this.countryList.filter(obj => obj === this.model.country);
        const StateValue = this.stateList.filter(obj => obj === this.model.state);
        const DescribeValue = this.whatBestDescribeYouList.filter(obj => obj === this.model.what_best_describes_you);
        if (this.model.what_best_describes_you === 'What best describes you?' || DescribeValue.length === 0 || !this.model.what_best_describes_you || this.model.country === 'null' || this.model.country === '-------------' || CountryValue.length === 0 || this.model.state === 'null' || this.model.state === "---------" || StateValue.length === 0) {
            if (this.model.what_best_describes_you === 'What best describes you?' || !this.model.what_best_describes_you || DescribeValue.length === 0) {
                this.whatBestDescribesYou = false;
            }
            if (this.model.country === 'null' || this.model.country === '-------------' || CountryValue.length === 0)  {
                this.isValidCountry = false;
            }
            if (this.model.state === 'null' || this.model.state === "---------" || this.model.state === 'State' || StateValue.length === 0)  {
                this.isValidState = false;
            }
            return;
        }
        this.isValidPostalCode = true;
            if (this.model.country === 'United States') {
                const foundValue = this.zipcodeList.filter(obj => obj.State === this.model.state);
                if (foundValue.length > 0) {
                    const regExp = /[a-zA-Z]/g;
                    const postal_code = this.model.postal_code;
                    if (regExp.test(postal_code) || postal_code.length !== 5) {
                        this.isValidPostalCode = false;
                        return;
                    } else {
                        if (foundValue[0].Min <= parseInt(postal_code) && parseInt(postal_code) <= foundValue[0].Max) {
                            this.isValidPostalCode = true;
                        } else {
                            this.isValidPostalCode = false;
                            return;
                        }
                    }
                } else {
                    this.isValidState = false;
                    return;
                }
            }
            if (this.account.type === 'personal') {
                this.createPersonalAccount();
            }
            // tslint:disable-next-line:one-line
            else if (this.account.type === 'district') {
                this.createSchoolDistrictAccount();
            }
            // tslint:disable-next-line:one-line
            else if (this.account.type === 'school') {
                this.createSchoolTeacherAccount();
            }
            // tslint:disable-next-line:one-line
            else {
                this._toastrService.typeCustomError(`Please select an account type option to proceed.`);
            }
    }

    ngOnDestroy() {
        // this.urlSubcription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/login/new-user/new-user.component.ts